import { useMutation } from '@tanstack/react-query'
import apiClient from '../api/client'

async function fetchCheckoutUrl(): Promise<string> {
  const { data } = await apiClient.post<{ url: string }>('/api/v1/billing/checkout')
  return data.url
}

async function fetchPortalUrl(): Promise<string> {
  const { data } = await apiClient.post<{ url: string }>('/api/v1/billing/portal')
  return data.url
}

/** Redirects the browser to Stripe Checkout on success. */
export function useStartCheckout() {
  return useMutation({
    mutationFn: fetchCheckoutUrl,
    onSuccess: (url) => {
      window.location.href = url
    },
  })
}

/** Redirects the browser to the Stripe Customer Portal on success. */
export function useOpenPortal() {
  return useMutation({
    mutationFn: fetchPortalUrl,
    onSuccess: (url) => {
      window.location.href = url
    },
  })
}
